module.exports = __webpack_public_path__ + "img/placeholder-image.f2fb8e3f.png";